import { render } from "./clientCanceled.vue?vue&type=template&id=64cfd17a"
import script from "./clientCanceled.vue?vue&type=script&lang=js"
export * from "./clientCanceled.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__